// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* 
// ─────────────────────────────────────────────────────────────────────────────
// HOME PAGE STYLES
// Below-the-fold styles for the homepage that load after critical styles.
// The first section of the home page should go in critical.scss, while the
// rest of the home page styles go in here.
// ─────────────────────────────────────────────────────────────────────────────
*/

/* ******************* */
/*       COLLAGE       */
/* ******************* */

#collage {
  padding: var(--section-padding);

  .container {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-wrap: wrap;
    gap: 1rem;
    max-width: calc(var(--section-max-width) / 16 * 1rem);
    margin: 0 auto;
  }

  img {
    height: auto;
    width: calc(50% - 0.5rem);
    max-height: 256px;
    max-width: 256px;
    border-radius: 10px;
  }
}

/* TABLET */
@media only screen and (min-width: 34rem) {
  #collage {
    .container {
      gap: 1.5rem;
    }

    img {
      width: calc(25% - 1.125rem);
    }
  }
}

/* DESKTOP */
@media only screen and (min-width: 64rem) {
  #collage {
    .container {
      gap: 2rem;
    }

    img {
      width: calc(25% - 1.5rem);
    }
  }
}

/* ******************* */
/*    SINGLE COLUMN    */
/* ******************* */

#single-column {
  padding: var(--section-padding);

  .container {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
    gap: 2rem;
  }

  .topper {
    margin-bottom: -1rem;
  }
}

/* TABLET */
@media only screen and (min-width: 48rem) {
  #single-column {
    max-width: calc(504 / 16 * 1rem);
    margin: 0 auto;
  }
}

/* DESKTOP */
@media only screen and (min-width: 64rem) {
  #single-column {
    max-width: calc(544 / 16 * 1rem);
    margin: 0 auto;
  }

  h2 {
    max-width: 445px;
  }
}

/* ******************* */
/*        NUMBER       */
/* ******************* */

#number {
  padding: var(--section-padding);
  padding-top: 2rem;

  .container {
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
    margin-top: 80px;
  }

  .line {
    border-left: 1px solid var(--slate-300);
    height: 80px;
    width: 1px;
    position: absolute;
    left: 50%;
    margin-left: -3px;
    margin-top: -80px;
    top: 0;
  }

  .number {
    height: 56px;
    width: 56px;
    color: var(--slate-600);
    border: 1px solid var(--slate-300);
    border-radius: 999px;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: var(--white);
  }

  &.offset {
    margin-bottom: -60px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/local.css"],"names":[],"mappings":"AAAA;;;;;;;CAOC;;AAED,wBAAwB;AACxB,wBAAwB;AACxB,wBAAwB;;AAExB;EACE,+BAA+B;;EAE/B;IACE,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;IACf,SAAS;IACT,qDAAqD;IACrD,cAAc;EAChB;;EAEA;IACE,YAAY;IACZ,yBAAyB;IACzB,iBAAiB;IACjB,gBAAgB;IAChB,mBAAmB;EACrB;AACF;;AAEA,WAAW;AACX;EACE;IACE;MACE,WAAW;IACb;;IAEA;MACE,2BAA2B;IAC7B;EACF;AACF;;AAEA,YAAY;AACZ;EACE;IACE;MACE,SAAS;IACX;;IAEA;MACE,yBAAyB;IAC3B;EACF;AACF;;AAEA,wBAAwB;AACxB,wBAAwB;AACxB,wBAAwB;;AAExB;EACE,+BAA+B;;EAE/B;IACE,WAAW;IACX,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,kBAAkB;IAClB,SAAS;EACX;;EAEA;IACE,oBAAoB;EACtB;AACF;;AAEA,WAAW;AACX;EACE;IACE,gCAAgC;IAChC,cAAc;EAChB;AACF;;AAEA,YAAY;AACZ;EACE;IACE,gCAAgC;IAChC,cAAc;EAChB;;EAEA;IACE,gBAAgB;EAClB;AACF;;AAEA,wBAAwB;AACxB,wBAAwB;AACxB,wBAAwB;;AAExB;EACE,+BAA+B;EAC/B,iBAAiB;;EAEjB;IACE,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,kBAAkB;IAClB,gBAAgB;EAClB;;EAEA;IACE,uCAAuC;IACvC,YAAY;IACZ,UAAU;IACV,kBAAkB;IAClB,SAAS;IACT,iBAAiB;IACjB,iBAAiB;IACjB,MAAM;EACR;;EAEA;IACE,YAAY;IACZ,WAAW;IACX,uBAAuB;IACvB,kCAAkC;IAClC,oBAAoB;IACpB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,8BAA8B;EAChC;;EAEA;IACE,oBAAoB;EACtB;AACF","sourcesContent":["/* \n// ─────────────────────────────────────────────────────────────────────────────\n// HOME PAGE STYLES\n// Below-the-fold styles for the homepage that load after critical styles.\n// The first section of the home page should go in critical.scss, while the\n// rest of the home page styles go in here.\n// ─────────────────────────────────────────────────────────────────────────────\n*/\n\n/* ******************* */\n/*       COLLAGE       */\n/* ******************* */\n\n#collage {\n  padding: var(--section-padding);\n\n  .container {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    flex-wrap: wrap;\n    gap: 1rem;\n    max-width: calc(var(--section-max-width) / 16 * 1rem);\n    margin: 0 auto;\n  }\n\n  img {\n    height: auto;\n    width: calc(50% - 0.5rem);\n    max-height: 256px;\n    max-width: 256px;\n    border-radius: 10px;\n  }\n}\n\n/* TABLET */\n@media only screen and (min-width: 34rem) {\n  #collage {\n    .container {\n      gap: 1.5rem;\n    }\n\n    img {\n      width: calc(25% - 1.125rem);\n    }\n  }\n}\n\n/* DESKTOP */\n@media only screen and (min-width: 64rem) {\n  #collage {\n    .container {\n      gap: 2rem;\n    }\n\n    img {\n      width: calc(25% - 1.5rem);\n    }\n  }\n}\n\n/* ******************* */\n/*    SINGLE COLUMN    */\n/* ******************* */\n\n#single-column {\n  padding: var(--section-padding);\n\n  .container {\n    width: 100%;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    text-align: center;\n    gap: 2rem;\n  }\n\n  .topper {\n    margin-bottom: -1rem;\n  }\n}\n\n/* TABLET */\n@media only screen and (min-width: 48rem) {\n  #single-column {\n    max-width: calc(504 / 16 * 1rem);\n    margin: 0 auto;\n  }\n}\n\n/* DESKTOP */\n@media only screen and (min-width: 64rem) {\n  #single-column {\n    max-width: calc(544 / 16 * 1rem);\n    margin: 0 auto;\n  }\n\n  h2 {\n    max-width: 445px;\n  }\n}\n\n/* ******************* */\n/*        NUMBER       */\n/* ******************* */\n\n#number {\n  padding: var(--section-padding);\n  padding-top: 2rem;\n\n  .container {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    position: relative;\n    margin-top: 80px;\n  }\n\n  .line {\n    border-left: 1px solid var(--slate-300);\n    height: 80px;\n    width: 1px;\n    position: absolute;\n    left: 50%;\n    margin-left: -3px;\n    margin-top: -80px;\n    top: 0;\n  }\n\n  .number {\n    height: 56px;\n    width: 56px;\n    color: var(--slate-600);\n    border: 1px solid var(--slate-300);\n    border-radius: 999px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    background-color: var(--white);\n  }\n\n  &.offset {\n    margin-bottom: -60px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
